/**
 * chunkArray
 *
 * Generator function that chunks an array into a given size
 *
 * @param arr - Array to chunk
 * @param size - Size of the chunks
 * @param index - Index to start at
 */
export function* chunkArray<T>(arr: T[], size = 50, index = 0) {
    for (let i = index; i < arr.length; i += size) {
        yield arr.slice(i, i + size);
    }
}
